import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import TabAttendance from "./TabAttendance";
import TabHoliday from "./TabHoliday";
import TabLocations from "./TabLocations";
import TabSchedules from "./TabSchedules";

import { tr } from "../../i18n";
const AttendancePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Ambil tab dari URL, default ke "attendance"
  const activeTab = searchParams.get("tab") || "attendance";

  // Fungsi ganti tab
  const handleTabChange = (tab) => {
    setSearchParams({ tab });
  };

  return (
    <div className="mt-5">
      {/* Tabs */}
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "attendance" ? "active" : ""}`}
            onClick={() => handleTabChange("attendance")}
          >
            {tr("common:menu.attendance")}
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "locations" ? "active" : ""}`}
            onClick={() => handleTabChange("locations")}
          >
            {tr("attendance:locations")}
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "holiday" ? "active" : ""}`}
            onClick={() => handleTabChange("holiday")}
          >
            {tr("attendance:holiday_schedule")}
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "schedules" ? "active" : ""}`}
            onClick={() => handleTabChange("schedules")}
          >
            {tr("attendance:template_schedule")}
          </button>
        </li>
      </ul>

      {/* Tab Content */}
      <div className="box-shadow nb-top">
        {activeTab === "attendance" && <TabAttendance />}
        {activeTab === "locations" && <TabLocations />}
        {activeTab === "holiday" && <TabHoliday />}
        {activeTab === "schedules" && <TabSchedules />}
      </div>
    </div>
  );
};

export default AttendancePage;
